var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.slide.settings.timer
        ? _c("TimerControl", { on: { subcommand: _vm.subcommand } })
        : _vm._e(),
      _vm._v(" "),
      _vm.slide.settings.subject
        ? _c("TeamStatusControl", {
            attrs: { subject: _vm.slide.settings.subject, type: "answers" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.scenario
        ? _c("div", { staticClass: "notice" }, [
            _vm._v("Er is geen scenario geselecteerd.")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }